module.exports = __webpack_public_path__ + "static/media/mail.9685c8c7.svg";